import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '写意武陵山水间——首届“武陵山杯”中小学生作文大赛';
const BASE_NAME = '20220907WLSB';
const route: RouteConfig = {
  path: '/20220907WLSB',
  name: BASE_NAME,
  component: () => import('./Home.vue'),
  redirect: `/${BASE_NAME}/First`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'First',
      component: () => import('./First.vue'),
      name: BASE_NAME + 'First',
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'Detail',
      component: () => import('./Detail.vue'),
      name: BASE_NAME + 'Detail',
      meta: {
        title: PAGE_TITLE,
        rank: 3,
      },
    },
    {
      path: 'ListPage',
      component: () => import('./ListPage.vue'),
      name: BASE_NAME + 'ListPage',
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'SearchPage',
      component: () => import('./SearchPage.vue'),
      name: BASE_NAME + 'SearchPage',
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'User',
      component: () => import('./User.vue'),
      name: BASE_NAME + 'User',
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'News',
      component: () => import('./News.vue'),
      name: BASE_NAME + 'News',
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
  ],
};

export default route;
